/** Deutsch. Fehlende Schlüssel fallen auf Niederländisch zurück. */
import type { Woordenboek } from '../index.ts';

export const de: Partial<Woordenboek> = {
  'app.naam': 'Mizen',
  'algemeen.opslaan': 'Speichern',
  'algemeen.annuleren': 'Abbrechen',
  'algemeen.sluiten': 'Schließen',
  'algemeen.verwijderen': 'Löschen',
  'algemeen.bewerken': 'Bearbeiten',
  'algemeen.terug': 'Zurück',
  'algemeen.volgende': 'Weiter',
  'algemeen.zoeken': 'Suchen',
  'algemeen.laden': 'Wird geladen',
  'algemeen.leeg': 'Hier ist noch nichts',
  'algemeen.fout': 'Etwas ist schiefgelaufen',
  'algemeen.opnieuw': 'Erneut versuchen',
  'algemeen.totaal': 'Gesamt',
  'algemeen.datum': 'Datum',
  'algemeen.bedrag': 'Betrag',
  'algemeen.omschrijving': 'Beschreibung',
  'algemeen.status': 'Status',
  'algemeen.aantal': 'Menge',
  'algemeen.prijs': 'Preis',
  'algemeen.btw': 'USt.',
  'algemeen.meer': 'Mehr',
  'algemeen.van': 'von',
  'algemeen.tot': 'bis einschließlich',
  'algemeen.periode': 'Zeitraum',
  'algemeen.ja': 'Ja',
  'algemeen.nee': 'Nein',
  'algemeen.verplicht': 'Dieses Feld ist erforderlich',
  'algemeen.exporteren': 'Exportieren',
  'algemeen.downloaden': 'Herunterladen',

  'nav.dashboard': 'Übersicht',
  'nav.verkoop': 'Rechnungen',
  'nav.uren': 'Zeiterfassung',
  'nav.inkoop': 'Belege und Einkauf',
  'nav.bank': 'Bank',
  'nav.relaties': 'Kunden und Lieferanten',
  'nav.rapporten': 'Zahlen',
  'nav.instellingen': 'Einstellungen',

  // Korte varianten voor de tabbalk op een telefoon, waar de volledige naam
  // niet leesbaar past.
  'nav.kort.dashboard': 'Start',
  'nav.kort.verkoop': 'Rechnungen',
  'nav.kort.uren': 'Zeiten',
  'nav.kort.inkoop': 'Einkauf',
  'nav.kort.bank': 'Bank',
  'nav.kort.relaties': 'Kontakte',
  'nav.kort.rapporten': 'Zahlen',
  'nav.kort.instellingen': 'Einstellung',
  'nav.hoofdmenu': 'Hauptmenü',
  'nav.naarInhoud': 'Zum Inhalt springen',
  'nav.administratieKiezen': 'Mandant wählen',
  'nav.afmelden': 'Abmelden',
  // Testumgebung und Rueckmeldungen
  'omgeving.test': 'Testumgebung',
  'omgeving.testUitleg':
    'Dies ist eine Vorabversion zum Ansehen und Beurteilen. Die Daten darin sind erfunden; legen Sie hier keine echte Buchhaltung an.',
  'feedback.knop': 'Etwas bemerkt?',
  'feedback.titel': 'Was faellt Ihnen auf?',
  'feedback.uitleg':
    'Schreiben Sie auf, was Ihnen auffaellt, egal wie klein. Wir notieren dazu, auf welchem Bildschirm Sie waren.',
  'feedback.soort': 'Worum geht es?',
  'feedback.soort.opmerking': 'Eine Anmerkung',
  'feedback.soort.fout': 'Etwas geht schief',
  'feedback.soort.wens': 'Das haette ich gern',
  'feedback.soort.vraag': 'Eine Frage',
  'feedback.bericht': 'Ihre Anmerkung',
  'feedback.naam': 'Ihr Name',
  'feedback.naamUitleg': 'Nur wenn wir auf Sie zurueckkommen duerfen.',
  'feedback.versturen': 'Senden',
  'feedback.verstuurd': 'Danke. Ihre Anmerkung ist notiert.',
  'feedback.overzicht': 'Anmerkungen',
  'feedback.leeg': 'Noch keine Anmerkungen.',
  'feedback.leegUitleg': 'Sobald jemand etwas bemerkt, erscheint es hier.',
  'feedback.scherm': 'Bildschirm',
  'feedback.wie': 'Von',
  'feedback.wanneer': 'Wann',
  'feedback.antwoord': 'Antwort',
  'feedback.antwoordPlaatsen': 'Antwort notieren',
  'feedback.status.nieuw': 'Neu',
  'feedback.status.opgepakt': 'In Arbeit',
  'feedback.status.verwerkt': 'Erledigt',
  'feedback.status.afgewezen': 'Nicht umsetzen',
  'feedback.aantalNieuw': 'neu',
  'feedback.alles': 'Alle',

  'auth.aanmelden': 'Anmelden',
  'auth.registreren': 'Konto erstellen',
  'auth.email': 'E-Mail-Adresse',
  'auth.wachtwoord': 'Passwort',
  'auth.naam': 'Ihr Name',
  'auth.wachtwoordEis': 'Mindestens 12 Zeichen. Ein kurzer Satz funktioniert gut und ist leicht zu merken.',
  'auth.nogGeenAccount': 'Noch kein Konto? Jetzt erstellen.',
  'auth.welAccount': 'Sie haben bereits ein Konto? Melden Sie sich an.',
  'auth.mfaTitel': 'Noch ein Schritt',
  'auth.mfaUitleg':
    'Geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein. Keine App zur Hand? Nutzen Sie einen Wiederherstellungscode.',
  'auth.mfaCode': 'Code',
  'auth.mfaBevestigen': 'Bestätigen',
  'auth.mfaInstellen': 'Zwei-Schritt-Verifizierung einrichten',
  'auth.mfaUitleglang':
    'Mit der Zwei-Schritt-Verifizierung reicht Ihr Passwort allein nicht aus, um an Ihre Buchhaltung zu kommen. Scannen Sie den Code mit einer Authenticator-App.',
  'auth.mfaGeheim': 'Scannen nicht möglich? Geben Sie diesen Schlüssel manuell ein:',
  'auth.mfaHerstelcodes': 'Wiederherstellungscodes',
  'auth.mfaHerstelcodesUitleg':
    'Bewahren Sie diese Codes sicher auf, zum Beispiel in einem Passwortmanager. Jeder Code funktioniert einmal.',
  'auth.mfaAan': 'Zwei-Schritt-Verifizierung ist aktiv',
  'auth.mfaUit': 'Zwei-Schritt-Verifizierung ist inaktiv',
  'auth.sessies': 'Geräte, auf denen Sie angemeldet sind',
  'auth.sessiesIntrekken': 'Andere Geräte abmelden',
  'auth.registratieGelukt': 'Ihr Konto wurde erstellt. Sie können sich jetzt anmelden.',

  'org.nieuweOrganisatie': 'Neue Organisation',
  'org.naam': 'Name der Organisation',
  'org.kvk': 'Handelsregisternummer',
  'org.abonnement': 'Tarif',
  'admin.nieuw': 'Neuer Mandant',
  'admin.naam': 'Name des Unternehmens',
  'admin.rechtsvorm': 'Rechtsform',
  'admin.schema': 'Kontenplan',
  'admin.schemaUitleg':
    'Der Kontenplan bestimmt, wo jeder Betrag landet. Wir richten einen vollständigen niederländischen Kontenplan für Sie ein; Sie können ihn jederzeit anpassen.',
  'admin.btwNummer': 'Umsatzsteuer-Identifikationsnummer',
  'admin.adres': 'Adresse',
  'admin.postcodePlaats': 'PLZ und Ort',
  'admin.iban': 'IBAN',
  'admin.boekjaar': 'Geschäftsjahr',
  'admin.kiezen': 'Mandant wählen',
  'admin.geenAdministraties': 'Sie haben noch keinen Mandanten. Legen Sie einen an, um zu beginnen.',
  'admin.actief': 'Sie arbeiten in',

  'dashboard.titel': 'Wie läuft Ihr Unternehmen?',
  'dashboard.omzet': 'Umsatz',
  'dashboard.omzetUitleg':
    'Alles, was Sie mit Ihrer Arbeit oder Ihren Produkten verdient haben, ohne Umsatzsteuer.',
  'dashboard.kosten': 'Kosten',
  'dashboard.kostenUitleg': 'Was Sie ausgegeben haben, um Ihre Arbeit zu erledigen, ohne Umsatzsteuer.',
  'dashboard.winst': 'Gewinn',
  'dashboard.winstUitleg': 'Umsatz minus Kosten. Darauf zahlen Sie letztlich Steuern.',
  'dashboard.banksaldo': 'Auf der Bank',
  'dashboard.banksaldoUitleg':
    'Der Saldo laut Buchhaltung. Er kann von Ihrer Banking-App abweichen, solange Umsätze offen sind.',
  'dashboard.teOntvangen': 'Noch zu erhalten',
  'dashboard.teOntvangenUitleg': 'Geld, das Kunden Ihnen noch schulden.',
  'dashboard.teBetalen': 'Noch zu zahlen',
  'dashboard.teBetalenUitleg': 'Geld, das Sie Lieferanten noch schulden.',
  'dashboard.btw': 'Erwartete Umsatzsteuer',
  'dashboard.btwUitleg':
    'Was Sie für diesen Zeitraum voraussichtlich zahlen oder zurückerhalten. Das ist eine Berechnung, keine Erklärung.',
  'dashboard.aandacht': 'Das braucht Ihre Aufmerksamkeit',
  'dashboard.teBoeken': 'Noch zu verarbeitende Banktransaktionen',
  'dashboard.ontbrekendeBonnen': 'Ausgaben ohne Beleg',
  'dashboard.geenAandacht': 'Alles ist aktuell. Gute Arbeit.',
  'dashboard.vergelijking': 'im Vergleich zum vorigen Zeitraum',

  'facturen.titel': 'Rechnungen',
  'facturen.nieuw': 'Neue Rechnung',
  'facturen.nieuweOfferte': 'Neues Angebot',
  'facturen.nummer': 'Nummer',
  'facturen.klant': 'Kunde',
  'facturen.factuurdatum': 'Rechnungsdatum',
  'facturen.vervaldatum': 'Zahlbar bis',
  'facturen.regels': 'Was liefern Sie?',
  'facturen.regelToevoegen': 'Zeile hinzufügen',
  'facturen.subtotaal': 'Zwischensumme',
  'facturen.totaal': 'Gesamtbetrag',
  'facturen.definitiefMaken': 'Festschreiben',
  'facturen.definitiefUitleg':
    'Die Rechnung erhält dann eine Nummer und geht in Ihre Buchhaltung ein. Ändern ist danach nicht mehr möglich; korrigiert wird mit einer Gutschrift.',
  'facturen.versturen': 'An den Kunden senden',
  'facturen.pdf': 'PDF ansehen',
  'facturen.ubl': 'UBL herunterladen',
  'facturen.crediteren': 'Gutschrift erstellen',
  'facturen.status.concept': 'Entwurf',
  'facturen.status.definitief': 'Festgeschrieben',
  'facturen.status.verzonden': 'Versendet',
  'facturen.status.deels_betaald': 'Teilweise bezahlt',
  'facturen.status.betaald': 'Bezahlt',
  'facturen.status.vervallen': 'Überfällig',
  'facturen.status.geannuleerd': 'Storniert',
  'facturen.leeg': 'Sie haben noch keine Rechnungen erstellt.',
  'facturen.leegUitleg':
    'Erstellen Sie Ihre erste Rechnung; wir sorgen dafür, dass sie korrekt verbucht wird.',
  'facturen.referentie': 'Referenz des Kunden',
  'facturen.notitie': 'Hinweis auf der Rechnung',
  'facturen.openstaand': 'Noch offen',
  // Rechnungsuebersicht: Filter und Summen
  'facturen.zoeken': 'Nach Nummer, Kunde oder Referenz suchen',
  'facturen.alles': 'Alle',
  'facturen.alleSoorten': 'Alle Arten',
  'facturen.alleStatussen': 'Alle Rechnungen',
  'facturen.alleenOpenstaand': 'Nur offene',
  'facturen.alleenVervallen': 'Nur ueberfaellige',
  'facturen.aantalGevonden': 'gefunden',
  'facturen.totaalBedrag': 'Gesamt berechnet',
  'facturen.totaalOpenstaand': 'Noch zu erhalten',
  'facturen.totaalVervallen': 'Davon ueberfaellig',
  'facturen.meerLaden': 'Mehr laden',
  'facturen.geenResultaat': 'Keine Rechnungen gefunden',
  'facturen.geenResultaatUitleg': 'Passen Sie Suche oder Filter an.',
  'facturen.filtersWissen': 'Filter loeschen',
  'facturen.dagenTeLaat': 'Tage ueberfaellig',
  'facturen.sorteerOp': 'Sortieren nach',
  'facturen.soort': 'Art',
  'facturen.soort.offerte': 'Angebot',
  'facturen.soort.factuur': 'Rechnung',
  'facturen.soort.creditnota': 'Gutschrift',
  'facturen.soort.proforma': 'Proforma',
  'facturen.status.vervallen_offerte': 'Abgelaufenes Angebot',

  // Zeiterfassung und Projekte
  'uren.titel': 'Zeiten',
  'uren.projecten': 'Projekte',
  'uren.weekstaat': 'Meine Stunden',
  'uren.nieuw': 'Zeit erfassen',
  'uren.project': 'Projekt',
  'uren.activiteit': 'Taetigkeit',
  'uren.geenActiviteit': 'Keine Taetigkeit',
  'uren.wie': 'Wer',
  'uren.duur': 'Dauer',
  'uren.minuten': 'Minuten',
  'uren.uur': 'Stunden',
  'uren.factureerbaar': 'Abrechenbar',
  'uren.tarief': 'Stundensatz',
  'uren.urenLabel': 'Stunden',
  'uren.minutenLabel': 'Minuten',
  'uren.wachtOpGoedkeuring': 'wartet auf Genehmigung',
  'uren.opslaan': 'Zeit speichern',
  'uren.leeg': 'Es wurden noch keine Stunden erfasst.',
  'uren.legUitleg': 'Erfassen Sie Ihre ersten Stunden; spaeter koennen Sie sie gemeinsam abrechnen.',
  'uren.alleenEigen': 'Sie sehen nur Ihre eigenen Stunden.',
  'uren.totaalDezeWeek': 'Dieser Zeitraum',
  'uren.indienen': 'Einreichen',
  'uren.goedkeuren': 'Genehmigen',
  'uren.afkeuren': 'Ablehnen',
  'uren.afkeurreden': 'Warum lehnen Sie diese Stunden ab?',
  'uren.factureren': 'Stunden abrechnen',
  'uren.factureerUitleg':
    'Aus den genehmigten Stunden entsteht ein Rechnungsentwurf. Sie pruefen ihn, bevor er endgueltig wird.',
  'uren.selectie': 'ausgewaehlt',
  'uren.selecteerAlles': 'Alle auswaehlen',
  'uren.status.concept': 'Entwurf',
  'uren.status.ingediend': 'Eingereicht',
  'uren.status.goedgekeurd': 'Genehmigt',
  'uren.status.afgekeurd': 'Abgelehnt',
  'uren.status.gefactureerd': 'Abgerechnet',
  'uren.eigenUrenNietGoedkeuren': 'Ihre eigenen Stunden prueft jemand anderes.',

  'projecten.titel': 'Projekte',
  'projecten.nieuw': 'Neues Projekt',
  'projecten.naam': 'Projektname',
  'projecten.code': 'Projektcode',
  'projecten.klant': 'Kunde',
  'projecten.geenKlant': 'Kein Kunde',
  'projecten.facturatie': 'Wie wird abgerechnet?',
  'projecten.facturatie.uurtarief': 'Nach Stundensatz',
  'projecten.facturatie.vaste_prijs': 'Festpreis',
  'projecten.facturatie.niet': 'Keine Abrechnung',
  'projecten.uurtarief': 'Stundensatz',
  'projecten.vastePrijs': 'Festpreis',
  'projecten.budget': 'Stundenbudget',
  'projecten.budgetUren': 'Stunden Budget',
  'projecten.geschreven': 'Erfasst',
  'projecten.teFactureren': 'Noch abzurechnen',
  'projecten.gefactureerd': 'Abgerechnet',
  'projecten.status.actief': 'Aktiv',
  'projecten.status.op_pauze': 'Pausiert',
  'projecten.status.afgerond': 'Abgeschlossen',
  'projecten.status.gearchiveerd': 'Archiviert',
  'projecten.leeg': 'Es gibt noch keine Projekte.',
  'projecten.leegUitleg': 'Legen Sie ein Projekt an; danach koennen Sie Stunden erfassen und abrechnen.',
  'projecten.activiteiten': 'Taetigkeiten',
  'projecten.activiteitToevoegen': 'Taetigkeit hinzufuegen',
  'projecten.budgetOp': 'Das Budget ist fast aufgebraucht.',
  'projecten.budgetOver': 'Das Budget ist ueberschritten.',

  'relaties.titel': 'Kunden und Lieferanten',
  'relaties.nieuw': 'Neuer Kontakt',
  'relaties.naam': 'Name',
  'relaties.soort': 'Art',
  'relaties.klant': 'Kunde',
  'relaties.leverancier': 'Lieferant',
  'relaties.beide': 'Beides',
  'relaties.email': 'E-Mail-Adresse',
  'relaties.telefoon': 'Telefon',
  'relaties.btwNummer': 'USt-IdNr.',
  'relaties.kvk': 'Handelsregisternummer',
  'relaties.iban': 'IBAN',
  'relaties.betalingstermijn': 'Zahlungsziel in Tagen',
  'relaties.leeg': 'Sie haben noch keine Kunden oder Lieferanten.',
  'relaties.dubbelWaarschuwing': 'Es gibt bereits einen Kontakt mit ähnlichem Namen: {namen}.',
  'relaties.tochAanmaken': 'Es ist wirklich eine andere Partei, trotzdem anlegen',

  'inkoop.titel': 'Belege und Eingangsrechnungen',
  'inkoop.nieuw': 'Beleg oder Rechnung erfassen',
  'inkoop.leverancier': 'Lieferant',
  'inkoop.factuurnummer': 'Rechnungsnummer des Lieferanten',
  'inkoop.document': 'Beleg oder Rechnung (PDF oder Foto)',
  'inkoop.documentUitleg':
    'Bewahren Sie immer den Originalbeleg auf. Das ist gesetzlich vorgeschrieben und bei einer Prüfung notwendig.',
  'inkoop.leeg': 'Sie haben noch keine Eingangsrechnungen erfasst.',
  'inkoop.dubbel': 'Dieser Lieferant hat diese Rechnungsnummer bereits gesendet.',

  'bank.titel': 'Bank',
  'bank.importeren': 'Kontoauszug einlesen',
  'bank.importUitleg':
    'Laden Sie einen Auszug bei Ihrer Bank herunter (CSV, MT940 oder CAMT.053) und ziehen Sie ihn hierher.',
  'bank.teVerwerken': 'Noch zu verarbeiten',
  'bank.verwerkt': 'Verarbeitet',
  'bank.voorstel': 'Vorschlag',
  'bank.voorstelWaarom': 'Warum dieser Vorschlag?',
  'bank.koppelen': 'Zuordnen',
  'bank.boeken': 'Buchen',
  'bank.opRekening': 'Auf ein Konto buchen',
  'bank.reconciliatie': 'Stimmt mein Banksaldo?',
  'bank.saldoGrootboek': 'Laut Buchhaltung',
  'bank.saldoAfschrift': 'Laut letztem Auszug',
  'bank.verschil': 'Differenz',
  'bank.sluitAan': 'Ihr Banksaldo stimmt mit Ihrer Buchhaltung überein.',
  'bank.sluitNietAan': 'Es besteht noch eine Differenz zwischen Auszug und Buchhaltung.',
  'bank.leeg': 'Es gibt noch keine Banktransaktionen. Lesen Sie einen Auszug ein.',
  'bank.geimporteerd': '{toegevoegd} neue Transaktionen hinzugefügt, {overgeslagen} waren bereits vorhanden.',

  'rapport.titel': 'Zahlen',
  'rapport.balans': 'Bilanz',
  'rapport.balansUitleg': 'Was Ihr Unternehmen an einem bestimmten Tag besitzt und schuldet.',
  'rapport.winstEnVerlies': 'Gewinn- und Verlustrechnung',
  'rapport.winstEnVerliesUitleg': 'Was in einem Zeitraum eingegangen und ausgegangen ist.',
  'rapport.saldibalans': 'Summen- und Saldenliste',
  'rapport.grootboek': 'Hauptbuch',
  'rapport.journaal': 'Journal',
  'rapport.ouderdom': 'Wer muss noch zahlen?',
  'rapport.btw': 'Umsatzsteuerübersicht',
  'rapport.activa': 'Aktiva',
  'rapport.passiva': 'Passiva und Eigenkapital',
  'rapport.opbrengsten': 'Erträge',
  'rapport.kosten': 'Aufwendungen',
  'rapport.resultaat': 'Ergebnis',
  'rapport.inBalans': 'Die Bilanz ist ausgeglichen.',
  'rapport.nietInBalans': 'Achtung: die Bilanz ist nicht ausgeglichen. Bitte wenden Sie sich an den Support.',
  'rapport.doorklikken': 'Klicken Sie auf einen Betrag, um zu sehen, woher er stammt.',
  'rapport.vorigePeriode': 'Voriger Zeitraum',
  'rapport.btwVoorbehoud':
    'Diese Übersicht ist eine Berechnung auf Basis Ihrer Buchhaltung und keine Steuerberatung. Prüfen Sie das Ergebnis oder lassen Sie es vor der Abgabe fachlich prüfen.',
  'rapport.btwTeBetalen': 'Zu zahlen',
  'rapport.btwTeVorderen': 'Zurückzufordern',
  'rapport.btwSaldo': 'Saldo',
  'rapport.btwAansluiting': 'Abstimmung mit dem Hauptbuch',
  'rapport.btwSluitAan': 'Die Übersicht stimmt genau mit Ihrem Hauptbuch überein.',
  'rapport.geenGegevens': 'In diesem Zeitraum gibt es noch keine Buchungen.',

  'instellingen.titel': 'Einstellungen',
  'instellingen.administratie': 'Angaben zu Ihrem Unternehmen',
  'instellingen.gebruikers': 'Wer hat Zugriff?',
  'instellingen.beveiliging': 'Sicherheit',
  'instellingen.taal': 'Sprache',
  'instellingen.thema': 'Darstellung',
  'instellingen.themaLicht': 'Hell',
  'instellingen.themaDonker': 'Dunkel',
  'instellingen.themaSysteem': 'Systemeinstellung folgen',
  'instellingen.auditTrail': 'Was ist passiert?',
  'instellingen.auditUitleg':
    'Jede wichtige Handlung wird protokolliert und kann nachträglich nicht geändert werden.',
  'instellingen.auditControle': 'Protokoll prüfen',
  'instellingen.auditOngeschonden': 'Das Protokoll ist vollständig und unverändert.',
  'instellingen.uitnodigen': 'Jemanden einladen',
  'instellingen.rol': 'Rolle',
  'instellingen.rolWijzigen': 'Rolle ändern',
  'algemeen.acties': 'Aktionen',
  'instellingen.nieuweLink': 'Neuer Link',
  'instellingen.uitnodigingTot': 'gultig bis',
  'instellingen.intrekkenVraag': 'Zugang entziehen fur',
  'instellingen.intrekkenUitleg': 'Die Person hat keinen Zugriff mehr auf diese Buchhaltung. Gebuchtes bleibt bestehen, mit ihrem Namen im Prufpfad. Sie konnen sie spater erneut einladen.',
  'instellingen.toegangIntrekken': 'Zugriff entziehen',
  'instellingen.perioden': 'Perioden',
  'instellingen.periodeBlokkeren': 'Sperren',
  'instellingen.periodeSluiten': 'Schließen',
  'instellingen.periodeHeropenen': 'Wieder öffnen',
  'instellingen.heropenReden': 'Warum muss diese Periode wieder geöffnet werden?',

  'rol.owner': 'Inhaber',
  'rol.admin': 'Administrator',
  'rol.bookkeeper': 'Buchhalter',
  'rol.accountant': 'Steuerberater',
  'rol.employee': 'Mitarbeiter',
  'rol.viewer': 'Betrachter',
  'rol.support': 'Support',

  'fout.validation_failed': 'An den eingegebenen Daten stimmt etwas nicht.',
  'fout.unauthenticated': 'Sie sind nicht (mehr) angemeldet.',
  'fout.mfa_required': 'Es fehlt noch ein zweiter Schritt.',
  'fout.forbidden': 'Dafür haben Sie keine Berechtigung.',
  'fout.not_found': 'Das existiert nicht (mehr).',
  'fout.version_conflict': 'Jemand anderes hat dies zwischenzeitlich geändert.',
  'fout.duplicate_document': 'Dieses Dokument existiert bereits.',
  'fout.period_closed': 'Diese Periode ist geschlossen.',
  'fout.entry_not_balanced': 'Die Buchung ist nicht ausgeglichen.',
  'fout.entry_immutable': 'Diese Buchung ist festgeschrieben und kann nicht geändert werden.',
  'fout.invoice_requirements_missing': 'Auf der Rechnung fehlen gesetzlich vorgeschriebene Angaben.',
  'fout.limit_reached': 'Die Grenze Ihres Tarifs ist erreicht.',
  'fout.rate_limited': 'Zu viele Anfragen hintereinander. Bitte versuchen Sie es gleich erneut.',
  'fout.internal_error': 'Bei uns ist etwas schiefgelaufen.',
  'fout.netwerk': 'Der Server war nicht erreichbar. Bitte prüfen Sie Ihre Verbindung.',
};
